<template>
  <div>
    <!-- 导出报表对话框 -->
    <el-dialog
      title="查看规则"
      :visible.sync="rulesVisible"
      width="680px"
      :before-close="handleClose"
    >
      <div class="rules">
        <div class="list">
          <div class="label">
            员工提成类型：
          </div>
          <div>按{{ ruleData.rule_type === 1 ? '门店' : '员工' }}业绩档位提点</div>
        </div>
        <div class="list">
          <div class="label">
            员工提成比例：
          </div>
          <div>
            <el-table
              :data="ruleData.staff_ladder_proportion"
              style="width: 100%"
            >
              <el-table-column
                prop="date"
                label="档位"
                width="150"
              >
                <template slot-scope="scope">
                  <span v-if="scope.$index === 0">基础档</span>
                  <div v-else>
                    <span>当月业绩大于{{ scope.row.ladder_value }}元</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="提点比例"
                width="150"
              >
                <template slot-scope="scope">
                  {{ scope.row.proportion }}%
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="指定商品提点"
                width="150"
              >
                <template slot-scope="scope">
                  共{{ scope.row.item_count }}件商品
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="showGoodsList(scope.row)"
                  >
                    查看
                  </el-button>
                  <!-- 选择商品 -->
                  <SpRulesGoodsSelect
                    v-model="scope.row.goodsVisible"
                    :rule-id="ruleData.rule_id"
                    :ladder-no="scope.row.ladder_no"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="list">
          <div class="label">
            编外提成比例：
          </div>
          <div class="danger-font">
            {{ ruleData.supernumerary }}%
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpRulesDialog',
  model: {
    prop: 'rulesVisible',
    event: 'rulesVisibleChange'
  },
  props: {
    rulesVisible: {
      type: Boolean, //模态框展示隐藏
      default: false
    },
    month: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ruleData: {}
    }
  },
  watch: {
    rulesVisible (newVal) {
      if (newVal) {
        console.log(newVal)
        this.init()
      }
    }
  },
  mounted () {
    if (this.rulesVisible) {
      this.init()
    }
  },
  methods: {
    async init () {
      const data = await this.$api.customerConversion.getRuleByMonth({
        month: this.month
      })
      if (data) {
        data.staff_ladder_proportion.forEach((v) => {
          v.goodsVisible = false
        })
        this.ruleData = data
      }
    },
    // 跳转导出列表
    goExportList () {
      this.$router.push({
        path: '/staffManagement/exportList?filestype=' + this.filesType,
        replace: true
      })
    },
    // 关闭导出报表对话框
    handleClose () {
      this.$emit('rulesVisibleChange', false)
    },

    // 展示已上传的商品列表
    showGoodsList (item) {
      item.goodsVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.export-left {
  display: inline-block;
  width: 80px;
}
.exportData {
  li {
    margin-bottom: 20px;
  }
}
.reports-list {
  display: flex;
  line-height: 36px;
}
.reports-list-items {
  flex-grow: 1;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.export-pagination {
  margin-top: 20px;
}
.tips {
  color: #999;
  font-size: 12px;
}
.rules {
  .list {
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    .label {
      width: 120px;
    }
  }
}
.danger-font {
  color: #f56c6c;
}
</style>
